module.exports = __webpack_public_path__ + "d79ba233e18fa2a7eb743f50eaff9448.woff";